import DocumentDO = App.Data.Explorer.DocumentDO;

export const yMaxScale = (derivedDocument: DocumentDO) => {
	return {
		min() {
			if (!derivedDocument.is_custom_boundaries_enabled) {
				return undefined;
			}
			return derivedDocument.custom_boundary_min;
		},
		max() {
			if (!derivedDocument.is_custom_boundaries_enabled) {
				return undefined;
			}
			return derivedDocument.custom_boundary_max;
		},
		stacked: false,
		beginAtZero: true,
		display: false,
		gridLines: {
			offsetGridLines: true,
		},
		ticks: {
			font: {
				size: 12,
			},
		},
	};
};
